export enum SalesInvoiceType {
    UNSPECIFIED = 'unspecified',
    MONTHLY = 'monthly',
    THROUGH_INVOICED = 'through-invoiced',
    BALANCE = 'balance',
}
